export const ARTICLES_QUERY_KEY = 'articles';
export const ARTICLE_QUERY_KEY = 'article';

export const articleKeys = {
  list: (search?: string) => [ARTICLES_QUERY_KEY, search] as const,
  detail: (id: number | string) => [ARTICLE_QUERY_KEY, id] as const,
};
